module.exports = __webpack_public_path__ + "img/custom-present-empty-model@2x.9a69edd4.png";